import { DocumentsFilterProvider } from '@features/documents/contexts/documents-filter/DocumentsFilterProvider';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import styles from './DocumentsPage.module.css';

const DocumentsPage = React.memo(
  (): React.ReactElement => (
    <DocumentsFilterProvider>
      <div data-testid="documents-page" className={styles.documentsPage}>
        <Outlet />
      </div>
    </DocumentsFilterProvider>
  )
);

DocumentsPage.displayName = 'DocumentsPage';

export { DocumentsPage };
